export default __webpack_public_path__ + "static/media/up.6be09474.svg";